/**
 * tracking_plan_id 枚举
 * key格式：页面_1级功能模块_2级功能模块_3级功能模块......_事件类型
 */
const trackingPlanIdEnum = {

  // 商品视频大卡页面相关
  productVideoListPage:{
    skuPop_add_to_cart: "15854", // 商品视频大卡页面，加购弹窗里面的，add_to_cart事件
    bottomBar_immediatelyBtn_resource_click: "15855", // 商品视频大卡页面，视频卡片底部操作栏，立即购买按钮点击事件
    bottomBar_cartIcon_resource_click: "15856", // 商品视频大卡页面，视频卡片底部操作栏，购物车图标点击事件
  },
  

  // 商品详情页相关
  productDetailPage:{
    skuPop_add_to_cart: "15857", // 商品详情页，加购弹窗里面的，add_to_cart事件
    bottomBar_addCartBtn_btn_click: "15858", // 商品详情页，底部操作栏，加入购物车按钮点击事件
    bottomBar_immediatelyBtn_btn_click: "15859" // 商品详情页，底部操作栏，立即购买按钮点击事件
  },
  // 店铺详情页相关

  // 首页相关

  // 搜索页相关

  // 档期详情页相关

};

export default trackingPlanIdEnum;
